import { generateCsvString } from '@enechain/eposition-utils'

import {
  type ContractDealReportModel,
  convertToContractCsvRow,
} from '~/pages/ContractList/models/contractDealReport'
import { type ContractCsvRow } from '~/pages/ContractList/types/types'

const ALL_CONTRACT_CSV_COLUMN_ORDER: Array<keyof ContractCsvRow> = [
  'dealtDate',
  'platformName',
  'eclearDealCode',
  'dealPosition',
  'areaCode',
  'settlementDifferenceTargetArea',
  'deliveryStartDate',
  'deliveryEndDate',
  'deliveryTypeString',
  'deliveryHourType',
  'volumeInKw',
  'totalDeliveryHour',
  'totalKwh',
  'unitPricePerKwh',
  'currentMarketPrice',
  'floatingIndexFormula',
  'mtm',
  'clearingFeeRate',
  'fee',
] as const

export function generateAllContractCsvString(
  data: ContractDealReportModel[],
  headerLabels: Record<keyof ContractCsvRow, string>,
): string {
  if (data.length === 0) {
    return ''
  }

  const csvRows = data.map(convertToContractCsvRow)

  // 値を持つ約定が 1 件も無い通常ケースでは列ごと落とし、既存の出力を変えない。
  const showSettlementDifferenceTargetArea = csvRows.some(
    (row) => row.settlementDifferenceTargetArea !== '',
  )

  const columnOrder = ALL_CONTRACT_CSV_COLUMN_ORDER.filter((col) => {
    if (col === 'settlementDifferenceTargetArea') {
      return showSettlementDifferenceTargetArea
    }
    return true
  })

  return generateCsvString(csvRows, columnOrder, headerLabels)
}
